import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$model;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!_vm.savingService.isConfiguring ? [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.presetServices.length === 0,
      "hide-selected": true,
      items: _vm.presetServices,
      "item-text": "display_name",
      "item-value": "id",
      placeholder: "Select a service",
      label: _vm.presetServices.length === 0 ? "No service available" : "Service",
      "hide-details": "auto",
      "return-object": "",
      clearable: ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "mt-2 mb-2"
        }, [_vm._v(" " + _vm._s(item.display_name) + " ")]), _c(VSpacer), _c(VBtn, {
          attrs: {
            icon: ""
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.startEditService(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-pen",
          attrs: {
            size: "0.75rem",
            title: "Edit service"
          }
        })], 1), _c(VBtn, {
          attrs: {
            icon: ""
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.removeService(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-trash",
          attrs: {
            size: "0.75rem",
            title: "Remove service"
          }
        })], 1)];
      }
    }, {
      key: "append-outer",
      fn: function fn() {
        return [_c(VIcon, {
          staticClass: "fas fa-plus",
          attrs: {
            title: "Add new service",
            small: ""
          },
          on: {
            click: function click($event) {
              return _vm.startEditService(null);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 4124752375),
    model: {
      value: _vm.model,
      callback: function callback($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !((_vm$model = _vm.model) !== null && _vm$model !== void 0 && _vm$model.id)
    },
    on: {
      click: function click($event) {
        return _vm.confirm();
      }
    }
  }, [_c(VIcon, {
    staticClass: "far fa-arrow-alt-circle-up mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Preset ")], 1)], 1)] : _vm._e(), _vm.savingService.isConfiguring ? _c("div", {
    staticClass: "subform-bordered"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.savingService.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.savingService.form, "valid", $$v);
      },
      expression: "savingService.form.valid"
    }
  }, [_c("div", {
    staticClass: "flex gap-2 items-start mt-3"
  }, [_c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "Service",
      type: "text",
      rules: [_vm.formRules.mustNotBeEmpty],
      required: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.savingService.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.savingService.form, "name", $$v);
      },
      expression: "savingService.form.name"
    }
  }), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    staticStyle: {
      "max-width": "12rem"
    },
    attrs: {
      label: "Default unit price ex vat €",
      type: "text",
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterDecimalKeyAllowNegative
    },
    model: {
      value: _vm.savingService.form.defaultUnitPriceExVatEuro,
      callback: function callback($$v) {
        _vm.$set(_vm.savingService.form, "defaultUnitPriceExVatEuro", $$v);
      },
      expression: "savingService.form.defaultUnitPriceExVatEuro"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.cancelEditService();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.savingService.form.valid
    },
    on: {
      click: function click($event) {
        return _vm.confirmEditService();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save ")], 1)], 1)], 1)])], 1) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };